/* vh life — lightweight motion engine (no deps). Respects prefers-reduced-motion. */
(function () {
  "use strict";
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function onReady(fn){ if(document.readyState!=="loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }

  onReady(function () {
    // ---- Scroll reveals ----
    var reveals = [].slice.call(document.querySelectorAll(".vh-reveal,[data-vh-reveal]"));
    if (reduced) {
      reveals.forEach(function(el){ el.classList.add("is-in"); });
    } else if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var el = e.target, d = el.getAttribute("data-vh-delay");
            if (d) el.style.transitionDelay = d + "ms";
            el.classList.add("is-in");
            io.unobserve(el);
          }
        });
      }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
      reveals.forEach(function (el) { io.observe(el); });
    } else { reveals.forEach(function(el){ el.classList.add("is-in"); }); }

    // ---- Count-ups ----
    var counts = [].slice.call(document.querySelectorAll("[data-vh-count]"));
    function runCount(el){
      var target = parseFloat(el.getAttribute("data-vh-count"));
      var dec = parseInt(el.getAttribute("data-vh-decimals")||"0",10);
      var pre = el.getAttribute("data-vh-prefix")||"", suf = el.getAttribute("data-vh-suffix")||"";
      if (reduced){ el.textContent = pre + target.toFixed(dec) + suf; return; }
      var start=null, dur=1300;
      function step(t){ if(!start)start=t; var p=Math.min((t-start)/dur,1); var v=(1-Math.pow(1-p,3))*target;
        el.textContent = pre + v.toFixed(dec) + suf; if(p<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    if ("IntersectionObserver" in window) {
      var cio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ runCount(e.target); cio.unobserve(e.target);} }); }, {threshold:.6});
      counts.forEach(function(el){ cio.observe(el); });
    } else counts.forEach(runCount);

    // ---- Dose / feel bars ----
    var bars = [].slice.call(document.querySelectorAll(".vh-bar__fill[data-vh-w]"));
    function fillBar(el){ el.style.setProperty("--vh-w", el.getAttribute("data-vh-w")); el.classList.add("is-in"); }
    if (reduced) bars.forEach(fillBar);
    else if ("IntersectionObserver" in window){
      var bio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ fillBar(e.target); bio.unobserve(e.target);} }); }, {threshold:.5});
      bars.forEach(function(el){ bio.observe(el); });
    } else bars.forEach(fillBar);

    // ---- Magnetic buttons (fine pointer only) ----
    if (!reduced && window.matchMedia("(hover:hover) and (pointer:fine)").matches){
      [].slice.call(document.querySelectorAll("[data-vh-magnetic]")).forEach(function(el){
        el.addEventListener("mousemove", function(ev){
          var r=el.getBoundingClientRect();
          el.style.transform="translate("+((ev.clientX-(r.left+r.width/2))*0.18)+"px,"+((ev.clientY-(r.top+r.height/2))*0.3)+"px)";
        });
        el.addEventListener("mouseleave", function(){ el.style.transform=""; });
      });
    }

    // ---- Sticky add-to-cart show/hide ----
    var atc = document.querySelector("[data-vh-atc]");
    if (atc){
      var anchor = document.querySelector("[data-vh-atc-anchor]");
      var cartDrawer = document.getElementById("cart-drawer");
      var update = function(){
        var trigger = anchor ? (anchor.getBoundingClientRect().bottom < 0) : (window.scrollY > window.innerHeight*0.9);
        var nearFoot = (window.scrollY + window.innerHeight) > (document.body.scrollHeight - 520);
        var drawerOpen = cartDrawer ? cartDrawer.hasAttribute("open") : false;
        atc.classList.toggle("is-show", trigger && !nearFoot && !drawerOpen);
      };
      window.addEventListener("scroll", update, {passive:true});
      // Hide immediately if the cart drawer opens (from any trigger, not just scroll), and
      // re-show on close if the scroll position still calls for it.
      if (cartDrawer && window.MutationObserver){
        new MutationObserver(update).observe(cartDrawer, {attributes:true, attributeFilter:["open"]});
      }
      update();
    }
  });
})();
